import React from "react";
import { Link } from "react-router-dom";
import {
  dashEmpties,
  DERIVED_LANDLORD_CONTRACT_STATE_LABELS,
  landlordContractStateDerivedTone,
  landlordLeaseNotesDisplay,
  landlordLeaseStatusBadgeTone,
  landlordLeaseTypeLabel,
  LEASE_STATUS_LABELS,
} from "./unitDetailHelpers";
import Badge from "./Badge";
import SectionCard from "./SectionCard";

export default function UnitStammdatenSection({
  unit,
  linksResolving,
  verwaltungLabel,
  bewirtschafterLabel,
  landlordLeaseContractStatusStr,
  landlordContractDerivedState,
  onOpenAssignModal,
}) {
  return (
          <SectionCard
            title="Stammdaten"
            subtitle="Grunddaten und aktuelle Struktur dieser Unit"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-[#0f172a] dark:text-[#eef2ff]">
              <div className="md:col-span-2 flex justify-end">
                <button
                  type="button"
                  onClick={onOpenAssignModal}
                  className="inline-flex items-center rounded-lg border border-black/10 bg-white px-3 py-2 text-sm font-semibold text-[#0f172a] hover:bg-slate-100 dark:border-white/[0.07] dark:bg-[#141824] dark:text-[#eef2ff] dark:hover:bg-[#111520]"
                >
                  Zuordnungen bearbeiten
                </button>
              </div>
              <div>
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Unit ID</p>
                <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">{unit.unitId}</p>
              </div>

              <div>
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Typ</p>
                <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">{unit.type}</p>
              </div>

              <div>
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Ort</p>
                <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">{unit.place}</p>
              </div>

              <div>
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">PLZ</p>
                <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">{unit.zip}</p>
              </div>

              <div>
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Adresse</p>
                <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">{unit.address}</p>
              </div>

              <div>
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Zimmer gesamt</p>
                <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">{unit.rooms}</p>
              </div>

              <div>
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Liegenschaft</p>
                <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">{unit.property_title || "—"}</p>
              </div>

              <div>
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Verwaltung</p>
                <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">
                  {unit.landlord_id ? (
                    linksResolving ? (
                      "…"
                    ) : (
                      <Link
                        to={`/admin/landlords/${encodeURIComponent(unit.landlord_id)}`}
                        className="text-sky-700 hover:underline dark:text-sky-400"
                      >
                        {verwaltungLabel || "—"}
                      </Link>
                    )
                  ) : (
                    "—"
                  )}
                </p>
              </div>

              <div>
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Bewirtschafter</p>
                <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">
                  {unit.property_manager_id ? (
                    linksResolving ? (
                      "…"
                    ) : (
                      <Link
                        to={`/admin/bewirtschafter/${encodeURIComponent(unit.property_manager_id)}`}
                        className="text-sky-700 hover:underline dark:text-sky-400"
                      >
                        {bewirtschafterLabel || "—"}
                      </Link>
                    )
                  ) : (
                    "—"
                  )}
                </p>
              </div>

              <div>
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Eigentümer</p>
                <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">
                  {unit.owner_id ? (
                    <Link
                      to={`/admin/owners/${encodeURIComponent(unit.owner_id)}`}
                      className="text-sky-700 hover:underline dark:text-sky-400"
                    >
                      {String(unit.ownerName ?? unit.owner_name ?? "").trim() || "—"}
                    </Link>
                  ) : (
                    "Kein Eigentümer zugeordnet"
                  )}
                </p>
              </div>

              <div>
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Verfügbar ab</p>
                <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">{unit.availableFrom || "-"}</p>
              </div>

              <div className="md:col-span-2 border-t border-black/10 pt-4 mt-2 dark:border-white/[0.07]">
                <p className="text-sm font-semibold text-[#0f172a] dark:text-[#eef2ff] mb-3">
                  Vertrag Vermieter
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Vertragsart</p>
                    <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">{landlordLeaseTypeLabel(unit)}</p>
                  </div>
                  <div>
                    <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Mietbeginn</p>
                    <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">
                      {dashEmpties(unit.leaseStartDate ?? unit.lease_start_date)}
                    </p>
                  </div>
                  <div>
                    <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Vertragsende</p>
                    <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">
                      {dashEmpties(unit.leaseEndDate ?? unit.lease_end_date)}
                    </p>
                  </div>
                  <div>
                    <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Kündigung eingereicht</p>
                    <p className="text-[13px] font-medium text-[#0f172a] dark:text-[#eef2ff]">
                      {dashEmpties(unit.noticeGivenDate ?? unit.notice_given_date)}
                    </p>
                  </div>
                  <div>
                    <p className="text-[10px] text-[#6b7a9a]">Kündigung wirksam</p>
                    <p className="text-[13px] font-medium text-[#eef2ff]">
                      {dashEmpties(
                        unit.terminationEffectiveDate ?? unit.termination_effective_date
                      )}
                    </p>
                  </div>
                  <div>
                    <p className="text-[10px] text-[#6b7a9a]">Rückgabe erfolgt</p>
                    <p className="text-[13px] font-medium text-[#eef2ff]">
                      {dashEmpties(
                        unit.returnedToLandlordDate ?? unit.returned_to_landlord_date
                      )}
                    </p>
                  </div>
                  <div>
                    <p className="text-[10px] text-[#6b7a9a]">Status</p>
                    <p className="text-[13px] font-medium text-[#eef2ff]">
                      {landlordLeaseContractStatusStr ? (
                        <Badge
                          tone={landlordLeaseStatusBadgeTone(
                            landlordLeaseContractStatusStr
                          )}
                        >
                          {LEASE_STATUS_LABELS[landlordLeaseContractStatusStr] ||
                            landlordLeaseContractStatusStr}
                        </Badge>
                      ) : (
                        <>
                          <Badge
                            tone={landlordContractStateDerivedTone(
                              landlordContractDerivedState
                            )}
                          >
                            {DERIVED_LANDLORD_CONTRACT_STATE_LABELS[
                              landlordContractDerivedState
                            ] || landlordContractDerivedState}
                          </Badge>
                          <span className="block text-xs text-[#6b7a9a] font-normal mt-1">
                            Abgeleitet aus Mietbeginn und Vertragsende (kein gespeicherter
                            Vertragsstatus).
                          </span>
                        </>
                      )}
                    </p>
                  </div>
                  <div className="md:col-span-2">
                    <p className="text-[10px] text-[#6b7a9a]">Notizen</p>
                    <p className="font-medium whitespace-pre-wrap">
                      {landlordLeaseNotesDisplay(unit)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </SectionCard>
  );
}
